<template>
    <div>
        <div style="height: 2px !important">
            <v-progress-linear :indeterminate="loading" :color="loading ? 'primary' : 'grey lighten-2'"
                :value="!loading ? 100 : 0"></v-progress-linear>
        </div>
        <v-row dense class="">
            <!-- CLIENT DETAILS / PROFILE / NOTES -->
            <v-col cols="" class="grey lighten-4" style="height: calc(100vh - 60px) !important; overflow-y: hidden">
                <v-row dense>
                    <v-col cols="12" class="white">
                        <div class="text-h5 primary--text d-flex px-5 py-5">
                            <v-tooltip bottom>                                                  
                                <template #activator="{ on, attrs }">
                                <v-btn
                                    icon
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="handleBackClick"
                                    class="mr-3"
                                    color="primary"
                                    elevation="0"
                                >
                                    <v-icon size="28">mdi-arrow-left</v-icon>
                                </v-btn>
                                </template>
                                <span>Back to Site Admin</span>
                            </v-tooltip>
                            Site:
                            <span class="font-weight-bold" v-if="$route.params.id === 'new'">New</span>
                            <span class="font-weight-bold" v-else>{{ site?.siteName }}</span>
                        </div>
                        <v-tabs background-color="grey darken-2" dark v-model="siteTab">
                            <v-tab href="#details"> Details </v-tab>
                            <v-tab href="#cabins"> Cabins </v-tab>
                            <v-tab href="#comparison"> Comparison Data </v-tab>
                            <!-- <v-tab href="#notes"> Notes </v-tab> -->
                            <!-- DETAILS -->
                            <v-tab-item value="details" class="grey lighten-3 pa-5"
                                style="height: calc(100vh - 225px) !important; overflow-y: scroll">
                                <v-row>
                                    <v-col cols="6">
                                        <v-row dense class="">
                                            <!--- DETAILS -->
                                            <v-col cols="12" class="d-flex align-center">
                                                <div class="mt-4 text-h7 font-weight-bold primary--text">SITE DETAILS
                                                </div>
                                            </v-col>
                                            <v-col cols="12"><v-divider class="mb-2" /></v-col>
                                            <v-col cols="8">
                                                <TextField BackgroundColor="white" label="Site Name"
                                                    v-model="site.siteName" />
                                            </v-col>
                                            <v-col cols="4">
                                                <TextField BackgroundColor="white" label="Box Name"
                                                    v-model="site.boxName" />
                                            </v-col>
                                            <v-col cols="12" class="d-flex align-center">
                                                <div class="flex-grow-1">
                                                    <DropdownAdvanced BackgroundColor="white" :items="organisations"
                                                        itemtext="name" itemvalue="entityId" label="Organisation"
                                                        v-model="site.orgId" @change="updateOrganisation" />
                                                </div>
                                                <div>
                                                    <v-btn icon @click="copyOrganisationDetails()"
                                                        :disabled="site.orgId === ''"><v-icon>icons8-copy</v-icon></v-btn>
                                                </div>
                                            </v-col>
                                            <v-col cols="12" class="d-flex align-center">
                                                <div class="flex-grow-1">
                                                    <DropdownAdvanced BackgroundColor="white"
                                                        :disabled="site.orgId === ''" :items="filterProjectsByOrgId()"
                                                        itemtext="name" itemvalue="entityId" label="Project"
                                                        v-model="site.projectId" />
                                                </div>
                                                <div>
                                                    <v-btn icon @click="copyProjectDetails()"
                                                        :disabled="site.projectId === ''"><v-icon>icons8-copy</v-icon></v-btn>
                                                </div>
                                            </v-col>
                                            <v-col cols="6">
                                                <TextField BackgroundColor="white" label="Contact First Name *"
                                                    v-model="site.contactFirstName"
                                                    :validate="validate.contactFirstName" />
                                            </v-col>
                                            <v-col cols="6">
                                                <TextField BackgroundColor="white" label="Contact Last Name *"
                                                    v-model="site.contactLastName"
                                                    :validate="validate.contactLastName" />
                                            </v-col>
                                            <v-col cols="6">
                                                <TextField BackgroundColor="white" label="Contact Job Title"
                                                    v-model="site.contactJobRole" />
                                            </v-col>
                                            <v-col cols="6">
                                                <TextField BackgroundColor="white" label="Telephone *"
                                                    v-model="site.telephone" />
                                            </v-col>
                                            <v-col cols="6">
                                                <TextField BackgroundColor="white" label="Email" v-model="site.email" />
                                            </v-col>
                                            <v-col cols="6">
                                                <TextField BackgroundColor="white" label="Website"
                                                    v-model="site.website" />
                                            </v-col>
                                            <!--- ADDRESS -->
                                            <v-col cols="12" class="d-flex align-center">
                                                <div class="mt-4 text-h7 font-weight-bold primary--text">ADDRESS</div>
                                            </v-col>
                                            <v-col cols="12"><v-divider class="mb-2" /></v-col>
                                            <v-col cols="12">
                                                <vuetify-google-autocomplete v-if="$route.params.id === 'new'"
                                                    label="Address Lookup" autocomplete="donotcomplete" solo
                                                    background-color="white" name="myapp-name" ref="addressInput"
                                                    types="" id="map" classname="form-control"
                                                    v-on:placechanged="getAddressData" country="gb" clearable>
                                                </vuetify-google-autocomplete></v-col>
                                            <v-col cols="6">
                                                <TextField BackgroundColor="white" label="Address Line 1"
                                                    v-model="site.addressLine1" />
                                            </v-col>
                                            <v-col cols="6">
                                                <TextField BackgroundColor="white" label="Address Line 2"
                                                    v-model="site.addressLine2" />
                                            </v-col>
                                            <v-col cols="6">
                                                <TextField BackgroundColor="white" label="Address Line 3"
                                                    v-model="site.addressLine3" />
                                            </v-col>
                                            <v-col cols="6">
                                                <TextField BackgroundColor="white" label="Town" v-model="site.town" />
                                            </v-col>
                                            <v-col cols="6">
                                                <TextField BackgroundColor="white" label="County"
                                                    v-model="site.county" />
                                            </v-col>
                                            <v-col cols="6">
                                                <TextField BackgroundColor="white" label="Postcode"
                                                    v-model="site.postcode" />
                                            </v-col>
                                            <v-col cols="12">
                                                <DropdownSimple BackgroundColor="white" :items="countries"
                                                    label="Country" v-model="site.country" />
                                            </v-col>
                                            <v-col cols="6">
                                                <TextField BackgroundColor="white" label="Latitude"
                                                    v-model="site.latitude" />
                                            </v-col>
                                            <v-col cols="6">
                                                <TextField BackgroundColor="white" label="Longitude"
                                                    v-model="site.longitude" />
                                            </v-col>
                                            <v-col cols="12" class="d-flex align-center">
                                                <div class="mt-4 text-h7 font-weight-bold primary--text">DIVISION /
                                                    REGION</div>
                                            </v-col>
                                            <v-col cols="6">
                                                <DropdownSimple BackgroundColor="white" :items="Array.isArray(org?.divisions) ? org.divisions : []"
                                                    label="Division" v-model="site.division" />
                                            </v-col>
                                            <v-col cols="6">
                                                <DropdownSimple BackgroundColor="white" :items="Array.isArray(org?.regions) ? org.regions : []"
                                                    label="Region" v-model="site.region" />
                                            </v-col>
                                            <v-col cols="12"><v-divider class="mb-2" /></v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-row dense>
                                            <!--- STATUS -->
                                            <v-col cols="12" class="d-flex align-center">
                                                <div class="mt-4 text-h7 font-weight-bold primary--text">STATUS</div>
                                            </v-col>
                                            <v-col cols="12"><v-divider class="mb-2" /></v-col>
                                            <v-col cols="6">
                                                <DropdownSimple BackgroundColor="white" :items="siteStatus"
                                                    label="Status" v-model="site.status" />
                                            </v-col>
                                            <v-col cols="6">
                                                <DropdownSimple BackgroundColor="white" :items="modes" label="Mode"
                                                    v-model="site.mode" />
                                            </v-col>
                                            <!-- START -->
                                            <v-col cols="12" class="d-flex align-center">
                                                <div class="mt-4 text-h7 font-weight-bold primary--text">DATES</div>
                                            </v-col>
                                            <v-col cols="6">
                                                <!--                                                {{ site.startDateTime }}-->
                                                <DatePicker BackgroundColor="white" label="Start Date"
                                                    v-model="site.startDateTime" :dense="true" :clearable="false" />
                                            </v-col>
                                            <v-col cols="6">
                                                <!--                                                {{ site.endDateTime }} -->
                                                <DatePicker BackgroundColor="white" label="End Date"
                                                    v-model="site.endDateTime" :dense="true" :clearable="false" />
                                            </v-col>
                                            <!-- TYPE -->
                                            <v-col cols="12" class="d-flex align-center">
                                                <div class="mt-4 text-h7 font-weight-bold primary--text">TYPE</div>
                                            </v-col>
                                            <v-col cols="12"><v-divider class="mb-2" /></v-col>
                                            <v-col cols="6">
                                                <DropdownSimple BackgroundColor="white" :items="siteTypes" label="Type"
                                                    v-model="site.type" />
                                            </v-col>
                                            <v-col cols="6">
                                                <TextField BackgroundColor="white" label="Number of Cabins"
                                                    v-model.number="site.cabins" type="number" />
                                            </v-col>
                                            <v-col cols="12">
                                                <DropdownMultiple BackgroundColor="white" :items="accommodationTypes"
                                                    label="Accommodation" v-model="site.accommodation" />
                                            </v-col>
                                            <!-- COSTS -->
                                            <v-col cols="12" class="d-flex align-center">
                                                <div class="mt-4 text-h7 font-weight-bold primary--text">COSTS</div>
                                            </v-col>
                                            <v-col cols="6" v-if="site.type === 'Diesel'">
                                                <TextField BackgroundColor="white" label="Cost Per Litre"
                                                    v-model.number="site.costPerLitre" type="number" />
                                            </v-col>
                                            <v-col cols="6" v-if="site.type !== 'Diesel'">
                                                <TextField BackgroundColor="white" label="Cost Per kWh"
                                                    v-model.number="site.costPerkWh" type="number" />
                                            </v-col>
                                            <v-col cols="6" v-if="site.type !== 'Diesel'">
                                                <TextField BackgroundColor="white" label="Standing Charge (per day)"
                                                    v-model.number="site.costStandingCharge" type="number" />
                                            </v-col>
                                            <v-col cols="6">
                                                <TextField BackgroundColor="white" label="Rental Charge (per day)"
                                                    v-model.number="site.rentalCost" type="number" />
                                            </v-col>
                                            <!-- PRODUCT -->
                                            <v-col cols="12" class="d-flex align-center">
                                                <div class="mt-4 text-h7 font-weight-bold primary--text">PRODUCT</div>
                                            </v-col>
                                            <v-col cols="12"><v-divider class="mb-2" /></v-col>
                                            <v-col cols="6">
                                                <DropdownSimple BackgroundColor="white" :items="products"
                                                    label="Product" v-model="site.productId" />
                                            </v-col>
                                            <v-col cols="6">
                                                <DropdownSimple BackgroundColor="white" :items="tiers" label="Tier"
                                                    v-model="site.tier" />
                                            </v-col>
                                            <v-col cols="6">
                                                <TextField BackgroundColor="white" label="Occupancy"
                                                    v-model="site.occupancy" />
                                            </v-col>
                                            <v-col cols="12">
                                                <v-checkbox label="Use Main Meter (Aggregated when not checked)"
                                                    v-model="site.useMainMeter" background="white" true-value="1"
                                                    false-value="0">
                                                    ></v-checkbox></v-col>
                                            <!-- NOTES -->
                                            <v-col cols="12" class="d-flex align-center">
                                                <div class="mt-4 text-h7 font-weight-bold primary--text">NOTES</div>
                                            </v-col>
                                            <v-col cols="12"><v-divider class="mb-2" /></v-col>
                                            <v-col cols="12"><TextArea background-color="white" label="Notes"
                                                    v-model="site.notes" rows="10"></TextArea></v-col>
                                            <v-col cols="12" v-if="site.createdUserId !== ''"
                                                class="d-flex align-center">
                                                <div class="mt-4 text-h7 font-weight-bold primary--text">METADATA</div>
                                            </v-col>
                                            <v-col cols="12" v-if="site.createdUserId !== ''"><v-divider
                                                    class="mb-2" /></v-col>
                                            <v-col cols="12" v-if="site.createdUserId !== ''">
                                                <div class="grey lighten-2 caption pa-5">
                                                    ID: {{ site.entityId }}<br />
                                                    Created: {{ MIX_findUserName(site.createdUserId) }} |
                                                    {{ $dayjs(site.createdDateTime).format('DD MMM YY HH:mm:ss')
                                                    }}<br />
                                                    Modified: {{ MIX_findUserName(site.modifiedUserId) }} |
                                                    {{ $dayjs(site.modifiedDateTime).format('DD MMM YY HH:mm:ss')
                                                    }}<br />
                                                    <div v-if="site.deleted">
                                                        Deleted: {{ MIX_findUserName(site.deletedUserId) }} |
                                                        {{ $dayjs(site.deletedDateTime).format('DD MMM YY HH:mm:ss')
                                                        }}<br />
                                                    </div>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                                <v-row dense class="my-4 justify-end">
                                    <v-col cols="2" class="d-flex justify-end align-center">
                                        <div class="flex-grow-1" style="width: 50%">
                                            <AppButton block buttonclass="grey" @click.native="cancelSite()">Cancel
                                            </AppButton>
                                        </div>
                                        <div class="flex-grow-1" style="width: 50%">
                                            <AppButton block buttonclass="secondary" @click.native="saveSite()">Save
                                            </AppButton>
                                        </div>
                                    </v-col>
                                </v-row>
                                <!--                                <v-row>-->
                                <!--                                    <pre>{{ site }}</pre>-->
                                <!--                                </v-row>-->
                            </v-tab-item>
                            <v-tab-item value="cabins" class="grey lighten-3 pa-5"
                                style="height: calc(100vh - 225px) !important; overflow-y: scroll">
                                <v-row>
                                    <v-col cols="12">
                                        <v-row dense class="">
                                            <!--- DETAILS -->
                                            <v-col cols="12" class="d-flex align-center">
                                                <div class="mt-4 text-h7 font-weight-bold primary--text">CABIN DETAILS
                                                </div>
                                            </v-col>
                                            <v-col cols="12"><v-divider class="mb-2" /></v-col>
                                            <v-col cols="4" v-for="(cabin, index) in site.cabins" :key="index"
                                                class="d-flex align-center justify-end">
                                                <div style="width: 50px !important" class="text-center">{{
                                                    MIX_indexToLetters(index) }}</div>
                                                <div class="flex-grow-1">
                                                    <TextField BackgroundColor="white" label="Cabin Name"
                                                        v-model="cabinNames[MIX_indexToLetters(index)]" />
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                                <v-row dense class="my-4 justify-end">
                                    <v-col cols="2" class="d-flex justify-end align-center">
                                        <div class="flex-grow-1" style="width: 50%">
                                            <AppButton block buttonclass="grey" @click.native="cancelSite()">Cancel
                                            </AppButton>
                                        </div>
                                        <div class="flex-grow-1" style="width: 50%">
                                            <AppButton block buttonclass="secondary" @click.native="saveSite()">Save
                                            </AppButton>
                                        </div>
                                    </v-col>
                                </v-row>
                                <!--                                <v-row>-->
                                <!--                                    <pre>{{ site }}</pre>-->
                                <!--                                </v-row>-->
                            </v-tab-item>
                            <v-tab-item value="comparison" class="grey lighten-3 pa-5"
                                style="height: calc(100vh - 225px) !important; overflow-y: scroll">
                                <v-row>
                                    <v-col>
                                        <div>
                                            <div class="d-flex align-center mb-2">
                                                <div class="text-h7 font-weight-bold primary--text">GET TEMPERATURE
                                                    USAGE AVERAGES</div>
                                            </div>

                                            <v-divider class="mb-4" />

                                            <!-- Date Pickers -->
                                            <div class="d-flex justify-space-between">
                                                <div style="width: 50%" class="pr-3">
                                                    <DatePicker BackgroundColor="white" label="Monitoring Start Date"
                                                        :initialdate="startDate" v-model="startDate" :dense="true"
                                                        :clearable="false" />
                                                </div>
                                                <div style="width: 50%">
                                                    <DatePicker BackgroundColor="white" label="Monitoring End Date"
                                                        :initialdate="endDate" v-model="endDate" :clearable="false"
                                                        :dense="true" />
                                                </div>
                                            </div>

                                            <div class="d-flex align-center justify-end mt-4">
                                                <VBtn @click.native="getComparisonData" class="primary">Get Averages
                                                </VBtn>

                                                <v-tooltip bottom>
                                                    <template #activator="{ on, attrs }">
                                                        <v-btn
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        @click="copyAllFromServer"
                                                        class="ml-2 primary"
                                                        :disabled="!averagesLoaded"
                                                        >
                                                        Copy All
                                                        </v-btn>
                                                    </template>
                                                    <span v-if="!averagesLoaded">Average data not ready</span>
                                                    <span v-else>Copy all values from server</span>
                                                </v-tooltip>
                                            </div>
                                            
                                        </div>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-row dense>
                                            <!-- Header -->
                                            <v-col cols="12" class="d-flex align-center">
                                                <div class="mt-4 text-h7 font-weight-bold primary--text">COMPARISON DATA
                                                    (ACCOMMODATION CIRCUITS ONLY) - Selected Circuit: {{
                                                    currentCircuitName }}
                                                </div>
                                            </v-col>
                                            <v-col cols="12"><v-divider class="mb-2" /></v-col>

                                            <!-- Tabs -->
                                            <v-col cols="12">
                                                <v-tabs v-model="selectedCircuitTab" background-color="grey lighten-4"
                                                    show-arrows grow class="mb-4">
                                                    <v-tab v-for="label in circuitTabs" :key="label">{{
                                                        label }}</v-tab>
                                                </v-tabs>
                                            </v-col>

                                            <!-- Matrix -->
                                            <v-row v-if="currentEnergyUsageMap">
                                                <v-col cols="4" v-for="(usage, index) in currentEnergyUsageMap"
                                                    :key="index" class="d-flex align-center justify-end">
                                                    <div style="width: 50px !important" class="text-center">{{ index }}
                                                        °C</div>
                                                    <div class="flex-grow-1 d-flex">
                                                        <TextField BackgroundColor="white" label="Average Usage"
                                                            v-model.number="currentEnergyUsageMap[index]"
                                                            @input="onUsageChange(index)"
                                                            type="number" />
                                                        <app-button @click.native="copyFromServer(index)"
                                                            buttonclass="primary mt-1"
                                                            :disabled="currentAverageDataMap[index] === 0 || currentAverageDataMap[index] === currentEnergyUsageMap[index]">
                                                            ← Copy
                                                        </app-button>
                                                        <span v-if="copiedFlags?.[circuitTabs[selectedCircuitTab]]?.[index]" class="ml-2 green--text d-flex align-center">
                                                            <v-icon small color="green" class="mr-1">mdi-check-circle</v-icon> Copied
                                                        </span>

                                                        <TextField BackgroundColor="white" label="Average from Server"
                                                            disabled v-model.number="currentAverageDataMap[index]"
                                                            type="number" />
                                                    </div>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                    </v-col>
                                </v-row>

                                <!-- Save / Cancel -->
                                <v-row dense class="my-4 justify-end">
                                    <v-col cols="2" class="d-flex justify-end align-center">
                                        <div class="flex-grow-1" style="width: 50%">
                                            <AppButton block buttonclass="grey" @click.native="cancelSite()">Cancel
                                            </AppButton>
                                        </div>
                                        <div class="flex-grow-1" style="width: 50%">
                                            <AppButton block buttonclass="secondary" @click.native="saveSite()">Save
                                            </AppButton>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-tab-item>


                        </v-tabs>
                    </v-col>
                </v-row>
            </v-col>

            <!-- CONFIRMATION BOX -->
            <ConfirmBox headerclass="primary" footerclass="grey lighten-2" :value="confirmBox"
                v-on:close="confirmBox = false">
                <template v-slot:header>
                    <div class="full-width d-flex align-center">
                        <div>Confirm</div>
                        <v-spacer />
                        <v-btn icon depressed @click="confirmBox = false"><v-icon>icons8-close</v-icon></v-btn>
                    </div>
                </template>
                <p>Please confirmed you want to delete this Vet</p>
                <strong>{{ site.name }}</strong><br />
                <!-- permenantDelete : {{ permenantDelete }}<br /> -->
                <!-- <CheckboxField v-model="permenantDelete">Permenantly Delete</CheckboxField> -->
                <template v-slot:footer>
                    <v-row>
                        <v-col cols="12" class="d-flex justify-end">
                            <AppButton buttonclass="grey" @click.native="confirmBox = false">Cancel</AppButton>
                            <AppButton buttonclass="warning" @click.native="confirmDeletesite">Confirm</AppButton>
                        </v-col>
                    </v-row>
                </template>
            </ConfirmBox>
        </v-row>

         <v-dialog v-model="showUnsavedChangesDialog" max-width="400">
        <v-card>
            <v-card-title class="headline">Unsaved Changes</v-card-title>
            <v-card-text>
            You have unsaved changes. Are you sure you want to leave without saving?
            </v-card-text>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="showUnsavedChangesDialog = false">Cancel</v-btn>
            <v-btn color="red" text @click="discardChangesAndGoBack">Discard</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    </div>

   
</template>

<script>

import { mapGetters } from 'vuex'
export default {
    name: 'ClientView',
    // data
    data: (vm) => ({
        loading: false,
        // GENERAL
        confirmBox: false,
        siteTab: 'details',
        site: {},
        org: {},
        validate: {},
        modes: [
            { text: 'Monitoring', value: 'monitoring' },
            { text: 'Peakshaving', value: 'peakshaving' },
            { text: 'Sequencer', value: 'sequencer' },
            { text: 'Maintenance', value: 'maintenance' }
        ],
        tiers: ['Tier 1', 'Tier 2', 'Tier 3', 'Tier 4', 'Tier 5', 'Tier 6', 'Tier 7', 'Tier 8', 'Tier 9', 'Tier 10', 'Tier 11', 'Tier 12'],
        accommodationCircuits: [],
        cabinNames: {},
        accommodationTypes: [
            { text: 'Single Story', value: 'singlestory' },
            { text: 'Double Story', value: 'doublestory' },
            { text: 'Modular Cabins', value: 'modularcabins' }
        ],
        startDate: vm.$dayjs().subtract(8, 'day').format('YYYY-MM-DD'),
        endDate: vm.$dayjs().subtract(8, 'day').format('YYYY-MM-DD'),
        startDateUnix: 0,
        endDateUnix: 0,
        selectedCircuitTab: null,
        circuitTabs: [],
        energyUsageMapByCircuit: { TOTAL: Array(20).fill(0) },
        averageDataByCircuit: { TOTAL: Array(20).fill(0) },
        energyUsageMap: {},
        copiedFlags: {},
        averagesLoaded: false,
        copyingAll: false,
        formDirty: false,             // Track if there are unsaved changes
        originalEnergyUsageMap: {},      // Snapshot for comparison
        showUnsavedChangesDialog: false,     // Controls modal visibility
        pendingNavigation: null       // Stores the navigation action if confirmed
    }),
    // computed
    computed: {
        ...mapGetters({
            GET_currentUserProfile: 'GET_currentUserProfile'
        }),
        currentCircuitId() {
            return this.circuitTabs[this.selectedCircuitTab] || 'TOTAL'
        },
        currentCircuitName() {
            if (this.currentCircuitId === 'TOTAL') return 'Total Usage'
            const match = this.circuits.find(c => c.id === this.currentCircuitId)
            return match ? match.name : this.currentCircuitId
        },
        currentEnergyUsageMap() {
            return this.energyUsageMapByCircuit[this.currentCircuitId] || null
        },
        currentAverageDataMap() {
            return this.averageDataByCircuit[this.currentCircuitId] || null
        }
    },
    // methods
    methods: {
        // Initialise
        async initialise() {
            this.loading = true
            //get users
            try {
                await this.MIX_getUsers()
            } catch (error) {
                console.error(error)
            }
            // Get Oraganisations
            try {
                await this.MIX_getOrganisations()
            } catch (error) {
                console.error(error)
            }
            // Get Projects
            try {
                await this.MIX_getProjects()
            } catch (error) {
                console.error(error)
            }
            // Get Lookups
            try {
                await this.MIX_getLookups()
            } catch (error) {
                console.error(error)
            }
            // Get Site
            if (this.$route.params.id !== 'new') {
                let siteResult = await this.REDIS_read('site', this.$route.params.id)
                let site = siteResult.data
                // Parse the cabin names
                if (site.cabinNames !== '' && site.cabinNames !== undefined) {
                    this.cabinNames = JSON.parse(site.cabinNames)
                }
                // Parse the energy usage map
                if (site.comparisonEnergyMap !== '' && site.comparisonEnergyMap !== undefined) {
                    this.energyUsageMap = JSON.parse(site.comparisonEnergyMap)
                    console.log(`📥 Loaded comparisonEnergyMap for site ${site.siteId}:`)
                    console.log('Top-level keys:', Object.keys(this.energyUsageMap))
                    if (this.energyUsageMap.TOTAL) {
                        console.log('TOTAL keys:', Object.keys(this.energyUsageMap.TOTAL).slice(0, 10))
                        console.log('TOTAL sample:', Object.entries(this.energyUsageMap.TOTAL).slice(0, 3))
                    }
                }
                console.log(site)
                this.site = site
                // Ensure occupancy is always a string value. If missing, null, or empty, default to "0" to prevent save errors
                this.site.occupancy = site.occupancy != null && site.occupancy !== "" ? String(site.occupancy) : "0";

                // Get siteanisation Profile
            } else {
                this.site = { ...this.$schema.site, occupancy: "0" } // defaults occupancy to 0 on new sites.
                this.updateOrganisation()
                //console.log(this.org)
                this.org = {divisions: []} // Empty org for new site to protect 
            }
            // Only call getCircuits if the site has required IDs
            if (this.site?.orgId && this.site?.siteId) {
                await this.getCircuits()
            } else {
                console.warn('Skipping getCircuits during init – new site or missing IDs.')
            }

            const map = this.energyUsageMap

            // ✅ Case 1: If already 3D structure
            if (map && typeof map['TOTAL'] === 'object') {
                this.energyUsageMapByCircuit = { ...map }
                this.averageDataByCircuit = {}

                for (const key of Object.keys(map)) {
                    this.$set(this.averageDataByCircuit, key, Array(20).fill(0))
                }

                const keys = Object.keys(map).filter(key => key !== 'TOTAL').sort()
                this.circuitTabs = ['TOTAL', ...keys]
                this.selectedCircuitTab = 'TOTAL'

                console.log('📦 Detected existing 3D map:')
                console.log('Selected tab:', this.selectedCircuitTab)
                console.log('Tabs:', this.circuitTabs)
                console.log('All keys in energyUsageMapByCircuit:', Object.keys(this.energyUsageMapByCircuit))
                console.log('Map for selected tab:', this.energyUsageMapByCircuit[this.selectedCircuitTab])
            }

            // ✅ Case 2: Legacy 2D → transform to 3D
            else if (
                map &&
                Object.keys(map).every(key => !isNaN(Number(key))) &&
                Object.keys(map).length === 20
            ) {
                const totalArray = Array(20).fill(0)
                for (let i = 0; i < 20; i++) {
                    totalArray[i] = Number(map[i]) || 0
                }

                this.energyUsageMapByCircuit = {}
                this.averageDataByCircuit = {}

                this.$set(this.energyUsageMapByCircuit, 'TOTAL', [...totalArray])
                this.$set(this.averageDataByCircuit, 'TOTAL', Array(20).fill(0))

                for (const circuitId of this.accommodationCircuits) {
                    this.$set(this.energyUsageMapByCircuit, circuitId, Array(20).fill(0))
                    this.$set(this.averageDataByCircuit, circuitId, Array(20).fill(0))
                }

                this.circuitTabs = ['TOTAL', ...this.accommodationCircuits]
                this.selectedCircuitTab = 'TOTAL'

                console.log('📦 Transformed 2D map to 3D:')
                console.log('Selected tab:', this.selectedCircuitTab)
                console.log('Tabs:', this.circuitTabs)
                console.log('All keys in energyUsageMapByCircuit:', Object.keys(this.energyUsageMapByCircuit))
                console.log('Map for selected tab:', this.energyUsageMapByCircuit[this.selectedCircuitTab])
            }

            this.loading = false
        },
            /**
             * Set the date field, based on the range passed in
             * @param range
             */
            setDateField(range) {
                if (range === 'week') {
                    this.startDate = this.$dayjs().subtract(7, 'day').format('YYYY-MM-DD')
                    this.endDate = this.$dayjs().format('YYYY-MM-DD')
                } else if (range === 'month') {
                    this.startDate = this.$dayjs().subtract(1, 'month').format('YYYY-MM-DD')
                    this.endDate = this.$dayjs().format('YYYY-MM-DD')
                } else if (range === 'quarter') {
                    this.startDate = this.$dayjs().subtract(1, 'day').subtract(3, 'month').format('YYYY-MM-DD')
                    this.endDate = this.$dayjs().format('YYYY-MM-DD')
                } else if (range === 'year') {
                    this.startDate = this.$dayjs().subtract(1, 'day').subtract(1, 'year').format('YYYY-MM-DD')
                    this.endDate = this.$dayjs().format('YYYY-MM-DD')
                }
            },
        async saveSite() {
                try {
                    let site = { ...this.site }
                    site.orgName = this.MIX_findOrganisationName(this.site.orgId)
                    site.projectName = this.MIX_findProjectName(this.site.projectId)
                    site.modifiedUserId = this.GET_currentUserProfile.entityId
                    site.modifiedDateTime = this.$dayjs().unix()
                    site.deleted = false
                    site.deletedDateTime = null
                    site.deletedUserId = null
                    site.costPerkWh = parseFloat(site.costPerkWh)
                    site.costPerLitre = parseFloat(site.costPerLitre)
                    site.comparisonkWh = parseFloat(site.comparisonkWh)
                    site.occupancy = site.occupancy != null && site.occupancy !== "" ? String(site.occupancy) : "0";

                    // Stringify the cabin names
                    site.cabinNames = JSON.stringify(this.cabinNames)
                    
                    // Stringify the energy usage map with validation
                    // Ensure TOTAL is a temperature→energy map (0-19), not a circuit map
                    const mapToSave = { ...this.energyUsageMapByCircuit }
                    
                    console.log('💾 Saving energyUsageMapByCircuit:', mapToSave)
                    console.log('💾 TOTAL keys:', Object.keys(mapToSave.TOTAL || {}))
                    console.log('💾 TOTAL sample values:', Object.entries(mapToSave.TOTAL || {}).slice(0, 3))
                    
                    // Validate TOTAL structure - should have numeric keys 0-19
                    if (mapToSave.TOTAL) {
                        const totalKeys = Object.keys(mapToSave.TOTAL)
                        const hasNumericKeys = totalKeys.some(k => !isNaN(Number(k)) && Number(k) >= 0 && Number(k) < 20)
                        const hasCircuitKeys = totalKeys.some(k => typeof mapToSave.TOTAL[k] === 'object')
                        
                        if (hasCircuitKeys && !hasNumericKeys) {
                            console.error('🚨 CORRUPTION DETECTED: TOTAL contains circuit objects instead of temperature values!')
                            console.error('🚨 TOTAL structure:', mapToSave.TOTAL)
                            this.MIX_alertBox({ show: true, message: 'ERROR: Energy map corrupted - cannot save', color: 'error', timeout: '6000' })
                            this.loading = false
                            return
                        }
                    }
                    
                    //site.comparisonEnergyMap = JSON.stringify(this.energyUsageMap)
                    site.comparisonEnergyMap = JSON.stringify(mapToSave)

                    Object.entries(site).forEach(([k, v]) => {
                        if (typeof v === 'object' && v !== null && !Array.isArray(v)) {
                            console.warn(`🚨 site.${k} is an object:`, v);
                        }
                    });

                    let result = null
                    if (this.$route.params.id === 'new') {
                        site.id = this.MIX_generateId()
                        site.siteId = site.id
                        site.createdUserId = this.GET_currentUserProfile.entityId
                        site.createdDateTime = this.$dayjs().unix()
                        result = await this.REDIS_createWithId('site', site, site.id)
                    } else {
                        result = await this.REDIS_update('site', site.id, site)
                    }
                    if (result.success) {
                        this.MIX_alertBox({ show: true, message: 'Project Saved', color: 'success', timeout: '2000' })
                        // this.$router.push('/site-admin')
                    }
                } catch (error) {
                    this.MIX_alertBox({ show: true, message: 'Error Saving Project', color: 'error', timeout: '4000' })
                    console.error(error)
                }
            },
            getAddressData: function (addressData, placeResultData) {
                let placeResult = this.MIX_googlePlacesConversion(JSON.stringify(placeResultData))
                this.site.AddressLine1 = placeResult.addressLine1
                this.site.AddressLine2 = placeResult.addressLine2
                this.site.town = placeResult.town
                this.site.county = placeResult.county
                this.site.postcode = placeResult.postcode
                this.site.country = placeResult.country
                this.site.latitude = placeResult.lat
                this.site.longitude = placeResult.lng
            },
            filterProjectsByOrgId() {
                if (this.site.orgId !== '') {
                    return this.projects.filter((project) => project.orgId === this.site.orgId)
                } else {
                    return []
                }
            },
            copyOrganisationDetails() {
                let org = this.organisations.find((org) => org.entityId === this.site.orgId)
                this.site.contactFirstName = org.contactFirstName
                this.site.contactLastName = org.contactLastName
                this.site.contactJobRole = org.contactJobRole
                this.site.addressLine1 = org.addressLine1
                this.site.addressLine2 = org.addressLine2
                this.site.town = org.town
                this.site.county = org.county
                this.site.postcode = org.postcode
                this.site.country = org.country
                this.site.telephone = org.telephone
                this.site.email = org.email
                this.site.website = org.website
                this.site.latitude = org.latitude
                this.site.longitude = org.longitude
            },
            copyProjectDetails() {
                let project = this.projects.find((project) => project.entityId === this.site.projectId)
                this.site.contactFirstName = project.contactFirstName
                this.site.contactLastName = project.contactLastName
                this.site.contactJobRole = project.contactJobRole
                this.site.telephone = project.telephone
                this.site.email = project.email
                this.site.website = project.website
            },
            cancelSite() {
                this.$router.push('/site-admin')
            },
            updateOrganisation() {
                this.org = this.organisations.find((org) => org.entityId === this.site.orgId)
            },
        async getComparisonData() {
                this.startDateUnix = this.$dayjs(this.startDate).tz('Europe/London').startOf('day').valueOf();
                this.endDateUnix = this.$dayjs(this.endDate).tz('Europe/London').endOf('day').valueOf();

                // Don't get data before site start date
                if (this.startDateUnix < this.$dayjs(this.site.startDateTime)) {
                    this.startDateUnix = this.$dayjs(this.site.startDateTime).tz('Europe/London').startOf('day').valueOf();
                }

                try {
                    const response = await this.$axios.post(`${process.env.VUE_APP_API_URL}publicV2/calculateCircuitAndSiteAverages`, {
                        orgId: this.site.orgId,
                        siteId: this.site.entityId,
                        circuits: this.accommodationCircuits,
                        startTimestamp: this.startDateUnix,
                        endTimestamp: this.endDateUnix,
                        aggregation: 'avg',
                        bucketSize: 3600000
                    });

                    if (response.data.success) {
                        const data = response.data.data;

                        // Initialize tabs and per-circuit data maps
                        this.circuitTabs = ['TOTAL', ...Object.keys(data.circuitAverages)];
                        this.selectedCircuitTab = 'TOTAL';

                        //this.energyUsageMapByCircuit = {};
                        this.averageDataByCircuit = {};

                        // Add TOTAL
                        //this.energyUsageMapByCircuit['TOTAL'] = [...data.siteTotal];
                        this.averageDataByCircuit['TOTAL'] = [...data.siteTotal];
                        console.log("Site total data:", data);

                        // Add each circuit
                        for (const [circuitId, values] of Object.entries(data.circuitAverages)) {
                            //this.energyUsageMapByCircuit[circuitId] = [...values];
                            this.averageDataByCircuit[circuitId] = [...values];
                        }
                    }
                    this.averagesLoaded = true; 
                    console.log("Selected tab:", this.selectedCircuitTab);
                    console.log("Available tabs:", this.circuitTabs);
                    console.log("energyUsageMapByCircuit:", this.energyUsageMapByCircuit);
                    console.log("Map for selected tab:", this.energyUsageMapByCircuit[this.selectedCircuitTab]);
                } catch (error) {
                    console.error('Error calculating circuit averages:', error);
                    this.averagesLoaded = false; // Optional fallback
                }
            },
        // GET CIRCUITS
        async getCircuits() {
            // Prevent request if adding a new site (missing orgId or siteId)
            if (!this.site || !this.site.orgId || !this.site.siteId) {
                console.warn('Skipping getCircuits(): Missing orgId or siteId for new site.')
                return
            }   
            let url = `${process.env.VUE_APP_API_URL}publicV2/circuits`
            
            await this.$axios
                .post(url, {
                    orgId: this.site.orgId,
                    siteId: this.site.siteId
                })
                .then((res) => {
                    this.circuits = res.data.data.documents.map((x) => x.value)
                    console.log('circuits.length = ' + this.circuits.length)

                    this.accommodationCircuits = this.circuits
                        .filter(c => c.accomodation === true)
                        .map(c => c.id)
                        .sort((a, b) => a.localeCompare(b))


                    //add 'All'
                    this.circuits.unshift({
                        id: 'All',
                        name: 'All',
                        group: 'All',
                        type: 'All',
                        boxLetter: 'All'
                    })

                    this.selectedSiteCircuits = ['All']
                    console.log(this.circuits)
                })
                .catch((err) => {
                    console.error('***** ' + err)
                })
        },

        copyFromServer(index) {
            // Get the actual circuit name (e.g., 'TOTAL', 'DBA1L1')
            const circuitId = this.circuitTabs[this.selectedCircuitTab]; 
            // Get the average value from the server-side map for the given index
            const avg = this.currentAverageDataMap?.[index];

            // Only proceed if a valid server value exists AND it differs from the current one
            if (
                avg != null &&
                this.currentEnergyUsageMap?.[index] !== avg
            ) {
                // Update the local usage value with the server-provided average
                this.$set(this.currentEnergyUsageMap, index, avg);
                
                // Ensure the copiedFlags object has a key for the circuit
                if (!this.copiedFlags[circuitId]) {
                    this.$set(this.copiedFlags, circuitId, {});
                }
                // Set the copied flag for this index
                this.$set(this.copiedFlags[circuitId], index, true);

                this.formDirty = true; // Mark dirty here too

                setTimeout(() => {
                this.$set(this.copiedFlags[circuitId], index, false);
                }, 2000); // Reset flag after 2 seconds
            }
        }, 
        
        copyAllFromServer() {
            let updatedCount = 0;

            Object.keys(this.averageDataByCircuit).forEach(circuitId => {
                const sourceMap = this.averageDataByCircuit[circuitId];
                const targetMap = this.energyUsageMapByCircuit[circuitId];
                if (!sourceMap || !targetMap) return;

                // Check if all values already match (or server value is 0)
                const needsUpdate = sourceMap.some((avgValue, index) => {
                avgValue = Number(avgValue);
                return !Number.isNaN(avgValue) && avgValue !== 0 && Number(targetMap[index]) !== avgValue;
                });

                if (!needsUpdate) return; // Skip this circuit entirely

                sourceMap.forEach((avgValue, index) => {
                avgValue = Number(avgValue);
                const currentValue = Number(targetMap[index]);

                if (!Number.isNaN(avgValue) && avgValue !== 0 && currentValue !== avgValue) {
                    this.$set(targetMap, index, avgValue);
                    updatedCount++;
                    this.formDirty = true;

                    if (!this.copiedFlags[circuitId]) {
                    this.$set(this.copiedFlags, circuitId, {});
                    }
                    this.$set(this.copiedFlags[circuitId], index, true);

                    setTimeout(() => {
                    this.$set(this.copiedFlags[circuitId], index, false);
                    }, 2000);
                }
                });
            });

            if (updatedCount > 0) {
                this.MIX_alertBox({
                show: true,
                message: `${updatedCount} record${updatedCount !== 1 ? 's' : ''} updated`,
                color: 'success',
                timeout: 3000
                });
            }
},

        setOriginalValuesFromServer(map) {
            this.originalEnergyUsageMap = JSON.parse(JSON.stringify(map));
            this.formDirty = false;
        },

        onUsageChange(index) {
            const newValue = this.currentEnergyUsageMap[index];
            const originalValue = this.originalEnergyUsageMap[index];

            // Only mark dirty if original value is NOT zero and the value has changed
            if (originalValue !== 0 && newValue !== originalValue) {
                this.formDirty = true;
            }
        }, 
         // Back button click
        handleBackClick() {
            if (this.formDirty) {
            this.showUnsavedChangesDialog = true;
            } else {
            this.navigateBack();
            }
        },

        // Discard and go back
        discardChangesAndGoBack() {
            this.showUnsavedChangesDialog = false;
            this.formDirty = false;
            this.navigateBack();
        },

        navigateBack() {
            this.$router.back(); // or however you navigate
        }

        },
        watch: {
        'site.orgId': {
            immediate: false,
            handler: async function (newVal, oldVal) {
            if (!newVal) return;

            console.log(`🔍 site.orgId changed from ${oldVal} to ${newVal}`);

            // Get projects again if orgId changes
            try {
                await this.MIX_getProjects();
                console.log('✅ Projects refreshed');
            } catch (error) {
                console.error('❌ Error fetching projects:', error);
            }

            // Update site.orgName
            this.site.orgName = this.MIX_findOrganisationName(newVal);

            // Update this.org with full organisation object
            const foundOrg = this.organisations.find(o => o.entityId === newVal);
            if (foundOrg) {
                this.org = foundOrg;
            } else {
                console.warn('⚠️ No matching org found for entityId:', newVal);
                this.org = { divisions: [] };
            }

            // Optional: Clear projectId if it no longer belongs to this org
            if (this.site.projectId) {
                const matchingProjects = this.projects.filter(p => p.orgId === newVal);
                const projectStillValid = matchingProjects.some(p => p.entityId === this.site.projectId);
                if (!projectStillValid) {
                this.site.projectId = '';
                }
            }
            }
        },

          // Whenever the currentEnergyUsageMap is loaded or changed from the server
            currentEnergyUsageMap: {
                deep: true,
                handler(newVal) {
                    // Only set original values when we first load from the server
                    if (!this.formDirty) {
                        this.originalEnergyUsageMap = JSON.parse(JSON.stringify(newVal));
                    }
                }
            }
        },
        created() {
            this.initialise()
        }
    }

</script>

<style scoped>
.d-flex {
    gap: 15px;
}

.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
    box-shadow: none !important;
}
</style>
